import React, { useState, useEffect, useRef } from 'react'
import { getSkillByDeptID } from '../Skills/subSkills/api/calls';
import XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import { compareAsc, format } from 'date-fns'
import moment from "moment";
import { attendenace } from '../../../Redux/Reducers/attendance_reducer';
import loader from "../../../img/loader.gif"

function EmpReportExlComp() {
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let token = JSON.parse(localStorage.getItem('key'));
    const divisionRef = useRef(null);
    const departmentRef = useRef(null);
    const fromdateRef = useRef(null);
    const todateRef = useRef(null);
    const empRef = useRef(null);
    const [divisionId, setDivisionId] = useState('')
    const [divisionList, setDivisionList] = useState([])

    const [departmentId, setDepartmentId] = useState('');
    const [departmentList, setDepartmentList] = useState([]);

    const [empid, setEmpid] = useState('')
    const [empList, setEmpList] = useState([])

    const [fromdate, setFromdate] = useState('')
    const [todate, setTodate] = useState('')


    const [reportCat, setReportCat] = useState('')


    const [errdivision, setErrdivision] = useState(false)
    const [errdepartment, setErrdepartment] = useState(false)
    const [erremp, setErremp] = useState(false)
    const [errfromdate, setErrfromdate] = useState(false)
    const [errtodate, setErrtodate] = useState(false)

    useEffect(() => {
        const getDivision = async () => {
            const response = await fetch(SERVER_URL + `api/common/department_list`,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'authorization': `bearer ${token.value}`
                    },
                }).then(res => res.json())
                .then(data => {
                    setDivisionList(data.result)
                })
        }
        getDivision()
    }, [])


    function divisionChange(divId) {
        setDivisionId(divId)
        getSkillByDeptID(divId).then((res) => {
            if (res.status) {
                setDepartmentList(res.data);
            }
        })
    }


    const handleChangeGetDept = (deptId) => {
        setDepartmentId(deptId)
        if (divisionId != '' && deptId != '') {
            getEmpByDivisionAndDepartment(divisionId, deptId)
        }
    }
    const getEmpByDivisionAndDepartment = async (divisionId, deptId) => {
        const response = await fetch(SERVER_URL + `api/employee/getBydivisionAndDepartment?division=${divisionId}&department=${deptId}`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            })
            .then(res => res.json())
            .then(res_data => {
                setEmpList(res_data.results)
            })
    }






    function convertMinutesToHoursAndMinutes(totalMinutes) {
        const HRS = Math.floor(totalMinutes / 60); // Calculate full hours
        const minutes = totalMinutes % 60; // Remaining minutes
        return `${HRS ? HRS : '00'}:${minutes ? minutes : '00'}`;
    }
    function attendenaceDayStatus(att_time) {
        // console.log('isHoliday=>', att_time)
        if (att_time < 240) {
            return 'Absent'
        }
        if (att_time >= 240 && att_time <= 420) {
            return 'Half day'
        }
        if (att_time >= 240) {
            return 'Present'
        }
    }
    const [loader, setLoader] = useState(false)
    const emp_Att_Report = () => {
        setErrdivision(false)
        setErrdepartment(false)
        setErrfromdate(false)
        setErrtodate(false)
        setErremp(false)

        if (divisionId == '' || divisionId == null || divisionId == undefined) {
            setErrdivision(true)
            divisionRef.current.focus();
            return false
        }
        if (departmentId == '' || departmentId == null || departmentId == undefined) {
            setErrdepartment(true)
            departmentRef.current.focus();
            return false
        }
        if (empid == '' || empid == null || empid == undefined) {
            setErremp(true)
            empRef.current.focus();
            return false
        }
        if (fromdate == '' || fromdate == null || fromdate == undefined) {
            fromdateRef.current.focus();
            setErrfromdate(true)
            return false
        }
        if (todate == '' || todate == null || todate == undefined) {
            todateRef.current.focus();
            setErrtodate(true)
            return false
        }
        else {
            setLoader(true)
            getEmpBySkill();
            get_holidays();

            // get_leaves();
        }

    }

    const [leave, setLeave] = useState([])
    const get_leaves = async () => {
        try {
            const response = await fetch(SERVER_URL + `api/reports/getleaves`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    userId: empid,
                    fromdate: fromdate,
                    todate: todate,
                }),
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const result = await response.json();
            // if (result.status == true) {
            // setHolidays(result.results)

            // } 
            // alert('ok ok ok ')
            // console.log('result=>', result)
            if (result.length > 0) {
                result.map((ind, item) => {

                })
            }

        } catch (err) {
            console.error('Error fetching data or generating the report:', err);
        }
    }

    const [holidays, setHolidays] = useState([])
    const get_holidays = async () => {
        // console.log('fromdate=>', fromdate)
        // console.log('todate=>', todate)
        try {
            const response = await fetch(SERVER_URL + `api/reports/getHolidays`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    fromdate: fromdate,
                    todate: todate,
                }),
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const result = await response.json();
            if (result.status == true) {
                setHolidays(result.results)
                // console.log('Holidays=>', result.results)
            }

        } catch (err) {
            console.error('Error fetching data or generating the report:', err);
        }
    }


    const [userDetails, setUserDetails] = useState(null)
    const getEmpBySkill = async () => {
        try {
            const response = await fetch(SERVER_URL + `api/reports/getempbyId`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`,
                },
                body: JSON.stringify({
                    userId: empid,
                }),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const result = await response.json();
            if (result.status === true) {
                setUserDetails(result.results);

                const newArray = [
                    [`${result?.results?.name}, Attendance In/Out Details From ${fromdate} To ${todate}`],
                    [`Company Name : ${result?.results?.cmp_name}, Department : ${result?.results?.deptName}`],
                    [`Employee Code : ${result?.results?.user_code}`],
                    ['Attendance Date', 'Start Time', 'End Time', 'Total HRS', 'Status', '', '', '', '', '']
                ];

                const getUserAttendance = async () => {
                    try {
                        const response = await fetch(SERVER_URL + `api/reports/userattendence?userId=${empid}&&fromdate=${fromdate}&&todate=${todate}`, {
                            method: 'GET',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'authorization': `bearer ${token.value}`,
                            },
                        });

                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }

                        const results = await response.json();

                        let startDate = moment(fromdate);
                        let endDate = moment(todate);

                        let temp_time = 0;
                        let temp_arr = [];
                        for (let m = moment(startDate); m.isSameOrBefore(endDate); m.add(1, 'days')) {
                            let temp_att = [];
                            const isObjectPresent = results.results.find((o) => moment(o.att_date).format('YYYY-MM-DD') === m.format('YYYY-MM-DD'));

                            const isHoliday = holidays.find(h => moment(h.holiday_date).format('YYYY-MM-DD') === m.format('YYYY-MM-DD'));
                            // console.log('else isHoliday', isHoliday)
                            if (isObjectPresent) {
                                temp_att.push(moment(isObjectPresent.att_date).format('YYYY-MM-DD'));
                                temp_att.push(isObjectPresent.start_time);
                                temp_att.push(isObjectPresent.end_time);
                                temp_att.push(convertMinutesToHoursAndMinutes(isObjectPresent.TOTALDAYSMINUTS));
                                // temp_att.push(attendenaceDayStatus(isObjectPresent.TOTALDAYSMINUTS));
                                temp_att.push(isHoliday ? isHoliday.holiday_name : attendenaceDayStatus(isObjectPresent.TOTALDAYSMINUTS));  // Add Holiday Status
                                temp_time = temp_time + isObjectPresent.TOTALDAYSMINUTS;
                            } else {

                                temp_att.push(m.format('YYYY-MM-DD'));
                                temp_att.push('00:00');
                                temp_att.push('00:00');
                                temp_att.push('00:00');
                                // temp_att.push('Absent');
                                temp_att.push(isHoliday ? `${isHoliday.holiday_name}` : 'Absent');  // Add Holiday Status
                            }

                            if (m.day() === 0) { // 0 represents Sunday
                                temp_att[4] = 'Sunday'; // Append to Holiday Status column
                            }
                            if (m.day() === 6) { // 0 represents Sunday
                                temp_att[4] = 'Saturday'; // Append to Holiday Status column
                            }
                            // Add the current row to newArray
                            newArray.push(temp_att);
                        }

                        temp_arr.push('Total HRS');
                        temp_arr.push('');
                        temp_arr.push('');
                        temp_arr.push(convertMinutesToHoursAndMinutes(temp_time));
                        temp_arr.push('');
                        temp_arr.push(''); // Empty for Holiday Status

                        newArray.push(temp_arr);
                        return newArray; // Return the populated array
                    } catch (error) {
                        console.error('Error fetching attendance data:', error);
                        return []; // Return an empty array in case of an error
                    }
                };

                // Await the getUserAttendance function and wait for newArray to be populated
                const finalArray = await getUserAttendance();

                // Create the Excel file
                XlsxPopulate.fromBlankAsync()
                    .then((workbook) => {
                        const sheet = workbook.sheet(0);

                        // Iterate over the finalArray and populate the sheet
                        const lastRowIndex = finalArray.length;
                        finalArray.forEach((row, rowIndex) => {
                            row.forEach((cell, colIndex) => {
                                const cellRef = sheet.cell(rowIndex + 1, colIndex + 1).value(cell);

                                // Apply styles for headers
                                if (rowIndex === 0) {
                                    cellRef.style({
                                        bold: true,
                                        fontSize: 16,
                                        fill: 'C4E0EE', // Yellow background
                                        horizontalAlignment: 'center',
                                    });
                                }
                                if (rowIndex === 1) {
                                    cellRef.style({
                                        bold: true,
                                        fontSize: 13,
                                        fill: 'C4E0EE',
                                        horizontalAlignment: 'center',
                                    });
                                }
                                if (rowIndex === 2) {
                                    cellRef.style({
                                        bold: true,
                                        fontSize: 12,
                                        fill: 'C4E0EE',
                                        horizontalAlignment: 'center',
                                    });
                                }
                                if (rowIndex === 3) {
                                    cellRef.style({
                                        bold: true,
                                        fontSize: 13,
                                        fill: 'C4E0EE',
                                        // horizontalAlignment: 'center',
                                    });
                                }
                            });

                            // Check if the current date is a holiday and apply the color
                            const dateStr = row[0]; // Date is in the first column
                            const holiday = holidays.find(h => moment(h.holiday_date).format('YYYY-MM-DD') === dateStr);

                            // Check if the current date is a Saturday or Sunday
                            const dayOfWeek = moment(dateStr).day(); // 6 for Saturday, 0 for Sunday
                            if (holiday) {
                                sheet.range(`A${rowIndex + 1}:J${rowIndex + 1}`).style({
                                    fill: '0bdd85', // Light red background for holiday dates
                                });
                            } else if (dayOfWeek === 6 || dayOfWeek === 0) {
                                // Highlight Saturday and Sunday with light blue color
                                sheet.range(`A${rowIndex + 1}:J${rowIndex + 1}`).style({
                                    fill: 'fde088', // Light blue background for Saturday and Sunday
                                });
                            }
                        });

                        sheet.range(`A${lastRowIndex}:C${lastRowIndex}`).merged(true);
                        sheet.range("A1:J1").merged(true);
                        sheet.range("A2:J2").merged(true);
                        sheet.range("A3:J3").merged(true);

                        // Set column width
                        sheet.column(1).width(18);
                        sheet.column(2).width(12);
                        sheet.column(3).width(12);
                        sheet.column(4).width(12);
                        sheet.column(5).width(20); // For the Status column
                        sheet.column(6).width(15); // For the Holiday Status column

                        return workbook.outputAsync();
                    })
                    .then((blob) => {
                        const url = window.URL.createObjectURL(blob);
                        const anchor = document.createElement('a');
                        anchor.href = url;
                        anchor.download = 'attendance_report_with_holiday_and_weekend_status.xlsx'; // Specify the download file name
                        anchor.click(); // Simulate a click to trigger download
                        window.URL.revokeObjectURL(url); // Clean up the URL object after use
                        setLoader(false);
                        setLoader(false)
                        setDepartmentId('')
                        setDivisionId('')
                        setDivisionList([])
                        setFromdate('')
                        setTodate('')
                        setEmpList([])
                        setEmpid('')
                    })
                    .catch((err) => {
                        console.error("Error generating Excel file:", err);
                    });
            }
        } catch (err) {
            console.error('Error fetching data or generating the report:', err);
        }
    };


    const getDepartmentNameById = (id) => {
        const item = departmentList.find(obj => obj.id == id);
        return item ? item.name : "Not Found"
    };
    const getDivisionNameById = (id) => {
        const item = divisionList.find(obj => obj.id == id);
        return item ? item.name : "Not Found"
    };


    const departmentEmpReport = () => {

        setErrdivision(false)
        setErrdepartment(false)
        setErrfromdate(false)
        setErrtodate(false)
        if (divisionId == '' || divisionId == null || divisionId == undefined) {
            setErrdivision(true)
            divisionRef.current.focus();
            return false
        }
        if (departmentId == '' || departmentId == null || departmentId == undefined) {
            setErrdepartment(true)
            departmentRef.current.focus();
            return false
        }
        if (fromdate == '' || fromdate == null || fromdate == undefined) {
            fromdateRef.current.focus();
            setErrfromdate(true)
            return false
        }
        if (todate == '' || todate == null || todate == undefined) {
            todateRef.current.focus();
            setErrtodate(true)
            return false
        }
        else {
            setLoader(true)
            getDepartmentEmpByDeptId()
        }





    }
    const getDepartmentEmpByDeptId = async () => {
        try {
            const response = await fetch(SERVER_URL + `api/reports/getempbyDepartmentId`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`,
                },
                body: JSON.stringify({
                    deptId: departmentId,
                }),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const result = await response.json();
            // console.log('response=>', result)

            if (result?.results?.length > 0) {
                const newArray = [
                    ['Attendance In/Out Details'],
                    ['', '', '', ''],
                    ['Company Name : Q2a Media services pvt ltd'],
                    ['', '', '', ''],
                    [`From Date: ${fromdate} To Date: ${todate}`],
                    [`Division: ${getDivisionNameById(divisionId)}, Department: ${getDepartmentNameById(departmentId)}`],
                    ['Employee Code', 'Employee Name', 'Company Name', 'Branch Name', 'Department Name', 'Date Of Joining'],
                    ['', '', '', '', '', '']
                ];

                let startDate = moment(fromdate);
                let endDate = moment(todate);
                const dateHeaders = [];
                for (let m = moment(startDate); m.isSameOrBefore(endDate); m.add(1, 'days')) {
                    const formattedDate = m.format('YYYY-MM-DD');  // Date in 'YYYY-MM-DD' format
                    const dayOfWeek = m.format('dddd');  // Day of the week (e.g., Monday, Tuesday, etc.)
                    dateHeaders.push(`${dayOfWeek}, ${formattedDate}`);
                }
                newArray[6] = newArray[6].concat(dateHeaders.map(date => [`${date}`, ``, ``]).flat());
                newArray[7] = newArray[7].concat(dateHeaders.map(date => [`In Time`, `Out Time`, `Total HRS`]).flat());
                newArray[7] = newArray[7].concat(['Hours completed']);
                newArray[7] = newArray[7].concat(['Total working days in Month']);
                newArray[7] = newArray[7].concat(['Working day']);
                newArray[7] = newArray[7].concat(['Leaves']);
                newArray[7] = newArray[7].concat(['Hours require']);
                newArray[7] = newArray[7].concat(['Shortfall hours']);
                newArray[7] = newArray[7].concat(['Extra hours']);

                function convertMinutesToHoursAndMinutes(totalMinutes) {
                    const HRS = Math.floor(totalMinutes / 60); // Calculate full hours
                    const minutes = totalMinutes % 60; // Remaining minutes
                    return `${HRS ? HRS : '00'}:${minutes ? minutes : '00'}`;
                }
                const promises = result.results.map((getResult_data) => {


                    return fetch(SERVER_URL + `api/reports/userattendence?userId=${getResult_data.id}&&fromdate=${fromdate}&&todate=${todate}`, {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'authorization': `bearer ${token.value}`
                        },
                    }).then(res => res.json())
                        .then(res_data => {


                            const temp_att = [
                                getResult_data.user_code,
                                getResult_data.name,
                                getResult_data.cmp_name,
                                'Noida',
                                getResult_data.deptName,
                                moment(getResult_data.joining_date).format('DD,MMM YYYY')
                            ];



                            let startDate = moment(fromdate);
                            let endDate = moment(todate);

                            let total_working_hrs = 0
                            let total_working_days = 0
                            for (let m = moment(startDate); m.isSameOrBefore(endDate); m.add(1, 'days')) {
                                const isObjectPresent = res_data.results.find((o) =>
                                    moment(o.att_date).format('YYYY-MM-DD') === m.format('YYYY-MM-DD')
                                );

                                if (isObjectPresent) {
                                    temp_att.push(isObjectPresent.start_time);
                                    temp_att.push(isObjectPresent.end_time);
                                    temp_att.push(convertMinutesToHoursAndMinutes(isObjectPresent.TOTALDAYSMINUTS));


                                    total_working_hrs = total_working_hrs + isObjectPresent.TOTALDAYSMINUTS

                                    total_working_days = total_working_days + 1
                                    // temp_att.push(m.format('YYYY-MM-DD'))
                                } else {
                                    temp_att.push('');
                                    temp_att.push('');
                                    temp_att.push('');
                                    // temp_att.push(m.format('YYYY-MM-DD'))
                                }
                            }


                            temp_att.push(convertMinutesToHoursAndMinutes(total_working_hrs))
                            temp_att.push(totalBusinessDays)
                            temp_att.push(total_working_days)


                            // get emp leave


                            // return fetch(SERVER_URL + `api/reports/userattendence?userId=${getResult_data.id}&&fromdate=${fromdate}&&todate=${todate}`, {
                            //     method: 'GET',
                            //     headers: {
                            //         'Accept': 'application/json',
                            //         'Content-Type': 'application/json',
                            //         'authorization': `bearer ${token.value}`
                            //     },
                            // }).then(res => res.json())
                            //     .then(res_data => {

                            //     })


                            // get emp leave

                            temp_att.push('')
                            temp_att.push(total_working_days * 8)
                            // console.log(temp_att)
                            //return false




                            return temp_att;
                        });
                });

                Promise.all(promises).then((results) => {
                    results.forEach((temp_att) => {
                        newArray.push(temp_att);
                    });

                    // console.log('newArray=>', newArray); // Access after all fetch calls are complete



                    //Generate Excel report
                    XlsxPopulate.fromBlankAsync()
                        .then((workbook) => {
                            const sheet = workbook.sheet(0);
                            var setcolumn = 4
                            var setcolumnRow7 = 1


                            const mergeCellsInRow = (rowNumber, startColumn, endColumn) => {
                                if (startColumn < 1 || endColumn < 1) {
                                    console.error("Column numbers must be 1 or greater.");
                                    return;
                                }
                                if (startColumn >= endColumn) {
                                    console.error(`Invalid merge range: Start (${startColumn}) must be less than End (${endColumn}).`);
                                    return;
                                }

                                const startCell = sheet.cell(rowNumber, startColumn);
                                const endCell = sheet.cell(rowNumber, endColumn);
                                const range = sheet.range(startCell, endCell);

                                try {
                                    range.merged(true); // Merge the range
                                    range.style({
                                        horizontalAlignment: "center", // Center horizontally
                                        verticalAlignment: "center", // Center vertically
                                        bold: true, // Optional: Make text bold
                                        fontSize: 14, // Optional: Set font size
                                    });
                                    // console.log(`Merged cells in row ${rowNumber}, columns ${startColumn}-${endColumn}`);
                                } catch (error) {
                                    // console.error(`Error merging cells in row ${rowNumber}, columns ${startColumn}-${endColumn}:`, error.message);
                                }
                            };

                            const appendTextToRow = (rowNumber, columnNumber, textToAppend) => {
                                const cell = sheet.cell(rowNumber, columnNumber);
                                // console.log('cell=>', cell)
                                // const currentValue = cell.value() || ""; // Get the current value, or empty if not set
                                cell.value(textToAppend); // Append the new text
                                // console.log('rowNumber, columnNumber=>', rowNumber, columnNumber)
                            };


                            newArray.forEach((row, rowIndex) => {
                                // console.log(rowIndex, 'row=>', row)

                                row.forEach((cell, colIndex) => {

                                    // console.log(rowIndex, 'row=>',colIndex, row)
                                    const cellRef = sheet.cell(rowIndex + 1, colIndex + 1);
                                    cellRef.value(cell);



                                    if (rowIndex === 0) {
                                        cellRef.style({
                                            bold: true,
                                            italic: true,
                                            fontSize: 20,
                                            fill: 'FFFFFF',
                                            horizontalAlignment: 'center',
                                        });
                                    } else if (rowIndex >= 8) {
                                        // console.log('rowIndex :', row[0])
                                        //   console.log('rowIndex :', row[0] + moment(row[5]).format("DDMMYYYY"))
                                        const colLetterStart = getColumnLetter(colIndex);
                                        // sheet.cell(`${colLetterStart}${rowIndex}`).value(`${dayName}, ${formattedDate}`);
                                        sheet.cell(`${colLetterStart}${rowIndex}`).value();







                                        //  console.log('cell :',cell)
                                    } else if (rowIndex === 2 || rowIndex === 4) {
                                        cellRef.style({
                                            bold: true,
                                            italic: true,
                                            fill: 'FFFFFF',
                                        });
                                    }
                                    else if (rowIndex === 5) {
                                        cellRef.style({
                                            bold: true,
                                            italic: true,
                                            fill: 'aed9ff',
                                        });
                                    }
                                    else if (rowIndex === 7) {
                                        cellRef.style({
                                            bold: true,
                                            italic: true,
                                            // fill: 'FFFFFF',
                                        });
                                    }
                                    else if (rowIndex == 6) {

                                        // console.log('colIndex=>',colIndex)
                                        sheet.column(setcolumn).width(22);
                                        setcolumn = setcolumn + 3
                                        cellRef.style({
                                            bold: true,
                                            // italic: true,
                                            // fontSize: 10,
                                            // fill: 'FFFFFF',
                                            // horizontalAlignment: 'center',
                                        });

                                        mergeCellsInRow(7, setcolumn, setcolumn + 2); // Merge A1:D1
                                    }
                                    // else if (rowIndex == 7) {
                                    //     console.log('setcolumnRow7=>', setcolumnRow7)
                                    //     setcolumnRow7 = setcolumnRow7 + 3
                                    //     appendTextToRow(8, setcolumnRow7, "InTime");
                                    //     // appendTextToRow(8, setcolumnRow7 + 1, "OutTime");
                                    //     // appendTextToRow(8, setcolumnRow7 + 2, "Total HRS");
                                    //     // setcolumnRow7 = setcolumnRow7+3
                                    //     // appendTextToRow(8, setcolumnRow7, "OutTime");
                                    //     // setcolumnRow7 = setcolumnRow7+3
                                    //     // setcolumnRow7 = setcolumnRow7+1
                                    // }

                                    // else if (rowIndex == 6) {
                                    //     mergeCellsInRow(6, 1, 3); // Merge A1:D1
                                    //     mergeCellsInRow(6, 4, 6); // Merge B2:E2
                                    //     mergeCellsInRow(6, 7, 9 ); // Merge A3:C3
                                    // }

                                    // else {
                                    //     cellRef.style({
                                    //         fill: 'FFFFFF',
                                    //     });
                                    // }
                                });

                            });



                            // Merge header ranges
                            sheet.range("A1:BS1").merged(true);
                            sheet.range("A2:BS2").merged(true);
                            sheet.range("A3:BS3").merged(true);
                            sheet.range("A4:BS4").merged(true);
                            sheet.range("A5:BS5").merged(true);
                            sheet.range("A6:BS6").merged(true);

                            sheet.column(1).width(22);
                            sheet.column(2).width(20);
                            sheet.column(3).width(30);
                            sheet.column(4).width(22);
                            sheet.column(5).width(22);
                            sheet.column(6).width(22);
                            // sheet.column(7).width(202);
                            // sheet.column(8).width(220);

                            return workbook.outputAsync();
                        })
                        .then((blob) => {
                            const url = window.URL.createObjectURL(blob);
                            const anchor = document.createElement('a');
                            anchor.href = url;
                            anchor.download = 'attendance.xlsx';
                            anchor.click();
                            window.URL.revokeObjectURL(url);
                            setLoader(false)
                            setLoader(false)
                            setDepartmentId('')
                            setDivisionId('')
                            setDivisionList([])
                            setFromdate('')
                            setTodate('')
                            setEmpList([])
                            setEmpid('')
                        });

                });
            }

        } catch (error) {
            console.error('Error fetching data or generating the report:', error);
        }
    }
    var totalBusinessDays = 0;
    const getColumnLetter = (index) => {
        let letter = '';
        index++; // Adjust for 1-based index (A = 1, B = 2, ..., Z = 26)
        while (index > 0) {
            index--; // Convert to 0-based index
            letter = String.fromCharCode((index % 26) + 65) + letter;
            index = Math.floor(index / 26);
        }
        return letter;
    };



    const divisionalEmpReport = async () => {

        setErrdivision(false)
        setErrfromdate(false)
        setErrtodate(false)
        if (divisionId == '' || divisionId == null || divisionId == undefined) {
            setErrdivision(true)
            divisionRef.current.focus();
            return false
        }
        if (fromdate == '' || fromdate == null || fromdate == undefined) {
            fromdateRef.current.focus();
            setErrfromdate(true)
            return false
        }
        if (todate == '' || todate == null || todate == undefined) {
            todateRef.current.focus();
            setErrtodate(true)
            return false
        }
        else {
            setLoader(true)
            try {
                const response = await fetch(SERVER_URL + `api/reports/getempbyDivisionId`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'authorization': `bearer ${token.value}`,
                    },
                    body: JSON.stringify({
                        divId: divisionId,
                    }),
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const result = await response.json();
                if (result?.results?.length > 0) {
                    const newArray = [
                        ['Attendance In/Out Details'],
                        ['', '', '', ''],
                        ['Company Name : Q2a Media services pvt ltd'],
                        ['', '', '', ''],
                        [`From Date: ${fromdate} To Date: ${todate}`],
                        [`Division: ${getDivisionNameById(divisionId)}`],
                        ['Employee Code', 'Employee Name', 'Company Name', 'Branch Name', 'Department Name', 'Date Of Joining'],
                        ['', '', '', '', '', '']
                    ];

                    let startDate = moment(fromdate);
                    let endDate = moment(todate);
                    const dateHeaders = [];
                    for (let m = moment(startDate); m.isSameOrBefore(endDate); m.add(1, 'days')) {
                        const formattedDate = m.format('YYYY-MM-DD');  // Date in 'YYYY-MM-DD' format
                        const dayOfWeek = m.format('dddd');  // Day of the week (e.g., Monday, Tuesday, etc.)
                        dateHeaders.push(`${dayOfWeek}, ${formattedDate}`);
                    }
                    newArray[6] = newArray[6].concat(dateHeaders.map(date => [`${date}`, ``, ``]).flat());
                    newArray[7] = newArray[7].concat(dateHeaders.map(date => [`In Time`, `Out Time`, `Total HRS`]).flat());
                    newArray[7] = newArray[7].concat(['Hours completed']);
                    newArray[7] = newArray[7].concat(['Total working days in Month']);
                    newArray[7] = newArray[7].concat(['Working day']);
                    newArray[7] = newArray[7].concat(['Leaves']);
                    newArray[7] = newArray[7].concat(['Hours require']);
                    newArray[7] = newArray[7].concat(['Shortfall hours']);
                    newArray[7] = newArray[7].concat(['Extra hours']);

                    function convertMinutesToHoursAndMinutes(totalMinutes) {
                        const HRS = Math.floor(totalMinutes / 60); // Calculate full hours
                        const minutes = totalMinutes % 60; // Remaining minutes
                        return `${HRS ? HRS : '00'}:${minutes ? minutes : '00'}`;
                    }
                    const promises = result.results.map((getResult_data) => {


                        return fetch(SERVER_URL + `api/reports/userattendence?userId=${getResult_data.id}&&fromdate=${fromdate}&&todate=${todate}`, {
                            method: 'GET',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'authorization': `bearer ${token.value}`
                            },
                        }).then(res => res.json())
                            .then(res_data => {


                                const temp_att = [
                                    getResult_data.user_code,
                                    getResult_data.name,
                                    getResult_data.cmp_name,
                                    'Noida',
                                    getResult_data.deptName,
                                    moment(getResult_data.joining_date).format('DD,MMM YYYY')
                                ];



                                let startDate = moment(fromdate);
                                let endDate = moment(todate);

                                let total_working_hrs = 0
                                let total_working_days = 0
                                for (let m = moment(startDate); m.isSameOrBefore(endDate); m.add(1, 'days')) {
                                    const isObjectPresent = res_data.results.find((o) =>
                                        moment(o.att_date).format('YYYY-MM-DD') === m.format('YYYY-MM-DD')
                                    );

                                    if (isObjectPresent) {
                                        temp_att.push(isObjectPresent.start_time);
                                        temp_att.push(isObjectPresent.end_time);
                                        temp_att.push(convertMinutesToHoursAndMinutes(isObjectPresent.TOTALDAYSMINUTS));


                                        total_working_hrs = total_working_hrs + isObjectPresent.TOTALDAYSMINUTS

                                        total_working_days = total_working_days + 1
                                        // temp_att.push(m.format('YYYY-MM-DD'))
                                    } else {
                                        temp_att.push('');
                                        temp_att.push('');
                                        temp_att.push('');
                                        // temp_att.push(m.format('YYYY-MM-DD'))
                                    }
                                }


                                temp_att.push(convertMinutesToHoursAndMinutes(total_working_hrs))
                                temp_att.push(totalBusinessDays)
                                temp_att.push(total_working_days)


                                // get emp leave


                                // return fetch(SERVER_URL + `api/reports/userattendence?userId=${getResult_data.id}&&fromdate=${fromdate}&&todate=${todate}`, {
                                //     method: 'GET',
                                //     headers: {
                                //         'Accept': 'application/json',
                                //         'Content-Type': 'application/json',
                                //         'authorization': `bearer ${token.value}`
                                //     },
                                // }).then(res => res.json())
                                //     .then(res_data => {

                                //     })


                                // get emp leave

                                temp_att.push('')
                                temp_att.push(total_working_days * 8)
                                // console.log(temp_att)
                                //return false




                                return temp_att;
                            });
                    });

                    Promise.all(promises).then((results) => {
                        results.forEach((temp_att) => {
                            newArray.push(temp_att);
                        });

                        // console.log('newArray=>', newArray); // Access after all fetch calls are complete



                        //Generate Excel report
                        XlsxPopulate.fromBlankAsync()
                            .then((workbook) => {
                                const sheet = workbook.sheet(0);
                                var setcolumn = 4
                                var setcolumnRow7 = 1


                                const mergeCellsInRow = (rowNumber, startColumn, endColumn) => {
                                    if (startColumn < 1 || endColumn < 1) {
                                        console.error("Column numbers must be 1 or greater.");
                                        return;
                                    }
                                    if (startColumn >= endColumn) {
                                        console.error(`Invalid merge range: Start (${startColumn}) must be less than End (${endColumn}).`);
                                        return;
                                    }

                                    const startCell = sheet.cell(rowNumber, startColumn);
                                    const endCell = sheet.cell(rowNumber, endColumn);
                                    const range = sheet.range(startCell, endCell);

                                    try {
                                        range.merged(true); // Merge the range
                                        range.style({
                                            horizontalAlignment: "center", // Center horizontally
                                            verticalAlignment: "center", // Center vertically
                                            bold: true, // Optional: Make text bold
                                            fontSize: 14, // Optional: Set font size
                                        });
                                        // console.log(`Merged cells in row ${rowNumber}, columns ${startColumn}-${endColumn}`);
                                    } catch (error) {
                                        // console.error(`Error merging cells in row ${rowNumber}, columns ${startColumn}-${endColumn}:`, error.message);
                                    }
                                };

                                const appendTextToRow = (rowNumber, columnNumber, textToAppend) => {
                                    const cell = sheet.cell(rowNumber, columnNumber);
                                    // console.log('cell=>', cell)
                                    // const currentValue = cell.value() || ""; // Get the current value, or empty if not set
                                    cell.value(textToAppend); // Append the new text
                                    // console.log('rowNumber, columnNumber=>', rowNumber, columnNumber)
                                };


                                newArray.forEach((row, rowIndex) => {
                                    // console.log(rowIndex, 'row=>', row)

                                    row.forEach((cell, colIndex) => {

                                        // console.log(rowIndex, 'row=>',colIndex, row)
                                        const cellRef = sheet.cell(rowIndex + 1, colIndex + 1);
                                        cellRef.value(cell);



                                        if (rowIndex === 0) {
                                            cellRef.style({
                                                bold: true,
                                                italic: true,
                                                fontSize: 20,
                                                fill: 'FFFFFF',
                                                horizontalAlignment: 'center',
                                            });
                                        } else if (rowIndex >= 8) {
                                            // console.log('rowIndex :', row[0])
                                            //   console.log('rowIndex :', row[0] + moment(row[5]).format("DDMMYYYY"))
                                            const colLetterStart = getColumnLetter(colIndex);
                                            // sheet.cell(`${colLetterStart}${rowIndex}`).value(`${dayName}, ${formattedDate}`);
                                            sheet.cell(`${colLetterStart}${rowIndex}`).value();







                                            //  console.log('cell :',cell)
                                        } else if (rowIndex === 2 || rowIndex === 4) {
                                            cellRef.style({
                                                bold: true,
                                                italic: true,
                                                fill: 'FFFFFF',
                                            });
                                        }
                                        else if (rowIndex === 5) {
                                            cellRef.style({
                                                bold: true,
                                                italic: true,
                                                fill: 'aed9ff',
                                            });
                                        }
                                        else if (rowIndex === 7) {
                                            cellRef.style({
                                                bold: true,
                                                italic: true,
                                                // fill: 'FFFFFF',
                                            });
                                        }
                                        else if (rowIndex == 6) {

                                            // console.log('colIndex=>',colIndex)
                                            sheet.column(setcolumn).width(22);
                                            setcolumn = setcolumn + 3
                                            cellRef.style({
                                                bold: true,
                                                // italic: true,
                                                // fontSize: 10,
                                                // fill: 'FFFFFF',
                                                // horizontalAlignment: 'center',
                                            });

                                            mergeCellsInRow(7, setcolumn, setcolumn + 2); // Merge A1:D1
                                        }
                                        // else if (rowIndex == 7) {
                                        //     console.log('setcolumnRow7=>', setcolumnRow7)
                                        //     setcolumnRow7 = setcolumnRow7 + 3
                                        //     appendTextToRow(8, setcolumnRow7, "InTime");
                                        //     // appendTextToRow(8, setcolumnRow7 + 1, "OutTime");
                                        //     // appendTextToRow(8, setcolumnRow7 + 2, "Total HRS");
                                        //     // setcolumnRow7 = setcolumnRow7+3
                                        //     // appendTextToRow(8, setcolumnRow7, "OutTime");
                                        //     // setcolumnRow7 = setcolumnRow7+3
                                        //     // setcolumnRow7 = setcolumnRow7+1
                                        // }

                                        // else if (rowIndex == 6) {
                                        //     mergeCellsInRow(6, 1, 3); // Merge A1:D1
                                        //     mergeCellsInRow(6, 4, 6); // Merge B2:E2
                                        //     mergeCellsInRow(6, 7, 9 ); // Merge A3:C3
                                        // }

                                        // else {
                                        //     cellRef.style({
                                        //         fill: 'FFFFFF',
                                        //     });
                                        // }
                                    });

                                });



                                // Merge header ranges
                                sheet.range("A1:BS1").merged(true);
                                sheet.range("A2:BS2").merged(true);
                                sheet.range("A3:BS3").merged(true);
                                sheet.range("A4:BS4").merged(true);
                                sheet.range("A5:BS5").merged(true);
                                sheet.range("A6:BS6").merged(true);

                                sheet.column(1).width(22);
                                sheet.column(2).width(20);
                                sheet.column(3).width(30);
                                sheet.column(4).width(22);
                                sheet.column(5).width(22);
                                sheet.column(6).width(22);
                                // sheet.column(7).width(202);
                                // sheet.column(8).width(220);

                                return workbook.outputAsync();
                            })
                            .then((blob) => {
                                const url = window.URL.createObjectURL(blob);
                                const anchor = document.createElement('a');
                                anchor.href = url;
                                anchor.download = 'attendance.xlsx';
                                anchor.click();
                                window.URL.revokeObjectURL(url);
                                setLoader(false)
                                setDepartmentId('')
                                setDivisionId('')
                                setDivisionList([])
                                setFromdate('')
                                setTodate('')
                                setEmpList([])
                                setEmpid('')
                            });

                    });
                }
            } catch (error) {
                console.error('Error fetching data or generating the report:', error);
            }
        }
    }
    const handleReportType = (type) => {
        setDivisionId('')
        setDepartmentId('')
        setDepartmentList([])
        setFromdate('')
        setTodate('')
        setEmpid('')
        setEmpList([])
        setErrdivision(false)
        setErrdepartment(false)
        setErrfromdate(false)
        setErrtodate(false)
        setErremp(false)
        setReportCat(type)
    }
    return (
        <>
            <div className='row'>
                <div className='col-md-3'>
                    <div className='form-blk mb25'>
                        <div className='form-label'>Type of Report</div>
                        <div className='form-input'>
                            <select onChange={e => handleReportType(e.target.value)} value={reportCat} className="form-select">
                                <option value=''>Select Type of Report</option>
                                <option value='1'>Division</option>
                                <option value='2'>Department</option>
                                <option value='3'>Employee</option>
                            </select>
                        </div>
                    </div>
                </div>


                <div className={`col-md-3 ${(reportCat == 3 || reportCat == 2 || reportCat == 1) ? 'd-inline' : 'd-none'}`}>
                    <div className='form-blk mb25'>
                        <div className='form-label'>Division</div>
                        <div className='form-input'>
                            <select ref={divisionRef} style={{ borderColor: errdivision ? 'red' : '' }} onChange={e => divisionChange(e.target.value)} value={divisionId} className="form-select">
                                <option value=''>Select Division </option>
                                {
                                    divisionList?.map((item, ind) => {
                                        return <option key={item.id} value={item.id}>{item.name}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <div className={`col-md-3 ${(reportCat == 3 || reportCat == 2) ? 'd-inline' : 'd-none'}`}>
                    <div className='form-blk mb25'>
                        <div className='form-label'>Department</div>
                        <div className='form-input'>
                            <select style={{ borderColor: errdepartment ? 'red' : '' }} ref={departmentRef} value={departmentId} className="form-select" onChange={e => { handleChangeGetDept(e.target.value) }}>
                                <option value=''>Select Department </option>
                                {
                                    departmentList.map((item, ind) => {
                                        return <option key={item.id} value={item.id}>{item.name}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <div className={`col-md-3 ${reportCat == 3 ? 'd-inline' : 'd-none'}`}>
                    <div className='form-blk mb25'>
                        <div className='form-label'>Employee</div>
                        <div className='form-input'>
                            <select style={{ borderColor: erremp ? 'red' : '' }} ref={empRef} value={empid} className="form-select"
                                onChange={e => { setEmpid(e.target.value) }}
                            >
                                <option value=''>Select Employee </option>
                                {
                                    empList?.map((item, ind) => {
                                        return <option key={item.id} value={item.id}>{item.name}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <div className={`col-md-3 ${(reportCat == 3 || reportCat == 2 || reportCat == 1) ? 'd-inline' : 'd-none'}`}>
                    <div className='form-blk'>
                        <div className='form-label'>From Date</div>
                        <div className='form-input'>
                            <input style={{ borderColor: errfromdate ? 'red' : '' }} ref={fromdateRef} onChange={e => setFromdate(e.target.value)} type="date" className="form-control" value={fromdate} placeholder="Select From Date" />
                        </div>
                    </div>
                </div>
                <div className={`col-md-3 ${(reportCat == 3 || reportCat == 2 || reportCat == 1) ? 'd-inline' : 'd-none'}`}>
                    <div className='form-blk'>
                        <div className='form-label'>To Date</div>
                        <div className='form-input'>
                            <input style={{ borderColor: errtodate ? 'red' : '' }} ref={todateRef} type="date" onChange={e => setTodate(e.target.value)} className="form-control" value={todate} placeholder="Select To Date" />
                        </div>
                    </div>
                </div>
                <div className={`col-md-3 mb25 ${reportCat == 3 ? 'd-inline' : 'd-none'}`}>
                    <div className='form-blk'>
                        <label className="h22"></label>
                        <div className='form-input'>
                            <button className="btn_5"
                                onClick={emp_Att_Report}
                                disabled={loader}
                            >{loader == true && <i className='fa fa-circle-o-notch fa-spin mr05'></i>}  Download</button>
                        </div>
                    </div>
                </div>
                <div className={`col-md-3 mb25 ${reportCat == 2 ? 'd-inline' : 'd-none'}`}>
                    <div className='form-blk'>
                        <label className="h22"></label>
                        <div className='form-input'>
                            <button className="btn_5"
                                onClick={departmentEmpReport}
                                disabled={loader}
                            >{loader == true && <i className='fa fa-circle-o-notch fa-spin mr05'></i>}  Download</button>
                        </div>
                    </div>
                </div>
                <div className={`col-md-3 mb25 ${reportCat == 1 ? 'd-inline' : 'd-none'}`}>
                    <div className='form-blk'>
                        <label className="h22"></label>
                        <div className='form-input'>
                            <button className="btn_5"
                                onClick={divisionalEmpReport}
                                disabled={loader}
                            >{loader == true && <i className='fa fa-circle-o-notch fa-spin mr05'></i>}  Download</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EmpReportExlComp
